import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const assignedUsersStyles = makeStyles((theme: Theme) =>
    createStyles({
        main: {
            float: "right",
            margin: "0px 0px 0px 0px",
            padding: "0px 35px 5px 35px",
        },
    })
);
